module.exports = __webpack_public_path__ + "media/images/vimeo-94facb163b2031c26cb2f73a0ed89635.png";